<template>
  <div>
    <div class="text-center" v-if="!actors">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
      <div>
        <v-layout column class="mt-5">
          <v-flex xs12>
            <v-layout align-center justify-end fill-height>
              <!-- <v-btn rounded color="primary" class="text-capitalize mr-2" to="actors/new" v-if="$can('create actors')">
                Créer
                <v-icon right>mdi-plus-circle-outline</v-icon>
              </v-btn> -->
              <v-btn rounded color="primary" class="text-capitalize mr-2" :disabled="selected.length < 1"
                @click="deleting(selected)" v-if="$can('delete any actor')">
                Supprimer
                <v-icon right>mdi-trash-can-outline</v-icon>
              </v-btn>
              <v-btn rounded color="primary" class="text-capitalize mr-2" :disabled="selected.length < 1"
                @click="validating(selected)" v-if="$can('validate actors')">
                Valider
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
      <div>
        <v-layout column class="mt-10">
          <v-flex xs12>
            <v-layout align-center justify-end fill-height>
              <v-text-field v-model="searchName" label="Filter par nom, prénom ou contact" solo class="mr-2">
                <template v-slot:append-outer>
                  <v-btn rounded color="primary" class="text-capitalize mr-2" @click="searchActors()" :loading="loader"
                    :disabled="loading">
                    Rechercher
                    <v-icon right>mdi-magnify</v-icon>
                  </v-btn>
                  <v-btn rounded color="primary" class="text-capitalize mr-2" @click="filters()" :disabled="loading">
                    Filtres
                    <v-icon right>mdi-filter-outline</v-icon>
                  </v-btn>
                  <v-btn rounded color="primary" class="text-capitalize" @click="resetSearch()">
                    Réinitialiser
                    <v-icon right>mdi-filter-remove-outline</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
      <div v-show="filter">
        <v-layout column wrap class="mt-2"> Liste des filtres </v-layout>
        <v-layout column class="mt-2">
          <v-flex xs12>
            <v-layout align-center justify-end fill-height>
              <v-select :items="departments" v-model="department_id" item-text="name" item-value="id"
                label="Departement" solo class="mr-2" @click:clear="removeDepartment()" @change="loadMunicipalities()"
                clearable>
              </v-select>
              <v-select :items="municipalities" v-model="municipality_id" item-text="name" item-value="id"
                label="Commune" solo class="mr-2" @change="loadDistricts()" @click:clear="removeMunicipality()"
                clearable>
              </v-select>
              <v-select :items="districts" v-model="district_id" item-text="name" item-value="id" label="Arrondissement"
                solo class="mr-2" @change="loadTowns()" @click:clear="removeDistrict()" clearable>
              </v-select>
              <v-select :items="towns" v-model="town_id" item-text="name" item-value="id" label="Village"
                @click:clear="removeTown()" clearable solo>
              </v-select>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout column class="mt-2">
          <v-flex xs12>
            <v-layout align-center justify-end fill-height>
              <v-select :items="chains" v-model="value_chain_id" item-text="name" item-value="id"
                label="Chaine de valeur" solo class="mr-2" @click:clear="removeChain()" clearable>
              </v-select>
              <v-select :items="maillons" v-model="maillon_id" item-text="name" item-value="id" label="Maillon" solo
                class="mr-2" @click:clear="removeMaillon()" clearable>
              </v-select>
              <v-select :items="services" v-model="service_id" item-text="name" item-value="id" label="Service"
                @click:clear="removeService()" solo class="mr-2" clearable>
              </v-select>
              <v-select :items="organisations" v-model="organization_id" item-text="name" item-value="id"
                label="Organisation" solo class="mr-2" @click:clear="removeOrganization()" clearable>
              </v-select>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout column class="mt-2">
          <v-flex xs12>
            <v-layout align-center justify-end fill-height>
              <v-select :items="actor_types" v-model="type" item-text="name" item-value="name" label="Type" solo
                class="mr-2" @click:clear="removeType()" clearable>
              </v-select>
              <v-select :items="genders" v-model="gender" label="Genre" solo class="mr-2" @click:clear="removeGender()"
                clearable>
              </v-select>
              <v-select :items="ages" v-model="age" label="Age" solo class="mr-2" @click:clear="removeAge()" clearable>
              </v-select>
              <v-select :items="languages" v-model="language" item-text="name" item-value="name" label="Langue" solo
                class="mr-2" @click:clear="removeLanguage()" clearable>
              </v-select>
              <v-select :items="school_levels" v-model="instruction_level" item-text="name" item-value="name"
                label="Niveau d'instruction" clearable @click:clear="removeLevel()" solo>
              </v-select>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>

      <v-snackbar v-model="snackbar" :timeout="timeout" color="primary" :top="true" :right="true">
        {{ snackbar_message }}
      </v-snackbar>
      <div>
        <v-flex xs12>
          <div v-if="selected" class="mr-2">
            {{ selected.length }} / {{ totalItems }} sélectionnés
          </div>
        </v-flex>
        <v-data-table v-if="actors" v-model="selected" :headers="adminHeaders" :items="actors" :loading="loading"
          :mobile-breakpoint="600" loading-text="Loading... Please wait" show-select :page.sync="currentPage"
          :server-items-length="totalItems" :items-per-page.sync="rowsPerPageItems" :footer-props="footerProps"
          class="mt-2 mr-10">
          <template v-slot:item.profile="{ item }">
            <td>

              {{ item.event && item.event.user ? item.event.user['profile']['last_name'] +
                "" + item.event.user['profile']['first_name'] : "" }}

            </td>
          </template>
          <template v-slot:item.full_name="{ item }">
            <td v-if="item.actor">
              {{ item.actor.last_name }} {{ item.actor.first_name }}
            </td>
          </template>
          <template v-slot:item.validator_1="{ item }">
            <td v-if="item.user_level_one && item.user_level_one.profile">
              {{ item.user_level_one.profile.full_name }}
            </td>
            <td v-else>
              {{
                item.user_level_one ? item.user_level_one.username : ''
              }}

            </td>
          </template>

          <template v-slot:item.validator_2="{ item }">
            <td v-if="item.user_level_two && item.user_level_two.profile">
              {{ item.user_level_two.profile.full_name }}
            </td>
            <td v-else>
              {{
                item.user_level_two ? item.user_level_two.username : ''
              }}

            </td>
          </template>


          <template v-slot:item.chain="{ item }">
            <td v-if="item.actor && item.actor.chain">
              {{ item.actor.chain.name }}
            </td>
          </template>
          <template v-slot:item.maillon="{ item }">
            <td v-if="item.actor && item.actor.maillon">
              {{ item.actor.maillon.name }}
            </td>
          </template>

          <template v-slot:item.action="{ item }">
            <v-icon small class="mr-2" @click="showItem(item.actor)" v-if="$can('view actors')">
              mdi-eye-outline
            </v-icon>
            <v-icon small class="mr-2" @click="editItem(item.actor)"
              v-if="$can('edit all actors') || $can('edit own actors')">
              mdi-pencil-outline
            </v-icon>
            <v-icon small @click="deleting(item)" v-if="$can('delete own actors') || $can('delete any actor')">
              mdi-trash-can-outline
            </v-icon>
            <v-icon @click="validating(item)" v-if="$can('validate actors') && item.validate == false">
              mdi-check
            </v-icon>

            <v-icon @click="noValidating(item)" v-if="$can('validate actors') && item.validate == false">
              mdi-close
            </v-icon>

          </template>
        </v-data-table>
      </div>

      <div class="text-xs-center pt-2">
        <v-pagination v-model="currentPage" :length="pagination.last_page" total-visible="16">
        </v-pagination>
      </div>
      <v-layout justify-center>
        <v-dialog v-model="dialog_generate" persistent hide-overlay max-width="290">
          <v-card>
            <v-card-title class="headline">{{ dialog_title }}</v-card-title>
            <v-card-text>{{ delete_message }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn rounded color="orange" @click="cancel()">Non</v-btn>
              <v-btn :loading="loading" :disabled="loading" rounded color="primary" @click="choosen()">Oui</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" persistent hide-overlay max-width="550">
          <delete-with-password v-if="item" @cancel="cancel" @deleteItem="choosen" :item="item"
            :message="delete_message" :title="dialog_title"></delete-with-password>
        </v-dialog>


        <v-dialog v-model="dialog_no_validate" persistent max-width="550">
          <actor-validation-reject v-if="item" :item="item" :title="dialog_title" :message="delete_message"
            @cancel="dialog_no_validate = false" @noValidateItem="noValidate" />
        </v-dialog>

      </v-layout>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Vue from 'vue'
import JsonExcel from 'vue-json-excel'
import axios from 'axios'
import Permissions from '~/mixins/Permissions'
import DeleteWithPassword from '~/components/DeleteWithPassword'
import FileSaver from 'file-saver'
import { LMap, LTileLayer, LPopup } from 'vue2-leaflet'
import ActorValidationReject from "~/components/ActorValidationReject"

Vue.component('downloadExcel', JsonExcel)

export default {
  name: 'actors-list-validate',
  components: {
    LMap,
    LTileLayer,
    LPopup,
    DeleteWithPassword,
    ActorValidationReject
  },
  mixins: [Permissions],
  data() {
    return {
      filter: false,
      zoom: 7,
      center: [9.239, 2.31],
      dialog: false,
      dialog_no_validate: false,
      dialog_generate: false,
      actorId: null,
      searchTimer: null,
      all: [],
      loading: false,
      loader: false,
      value_chain_id: null,
      department_id: null,
      municipality_id: null,
      district_id: null,
      town_id: null,
      maillon_id: null,
      service_id: null,
      event_id: null,
      instruction_level: null,
      type: null,
      age: null,
      gender: null,
      organization_id: null,
      language: null,
      ages: ['< ou =35 ans', '>35 ans'],
      genders: ['Homme', 'Femme'],
      ids: [],
      footerProps: {
        'items-per-page-options': [5, 10, 15, 30, 50, 100, 500],
        'items-per-page-text': 'Lignes par page'
      },
      dialog_title: '',
      isBulkDelete: false,
      isBulkGenerate: false,
      isSingleDelete: false,
      isSingleGenerate: false,
      searchName: '',
      isValidate: false,
      snackbar: false,
      snackbar_message: '',
      delete_message: '',
      timeout: 5000,
      selected: [],
      adminHeaders: [
        { text: 'Nom Evènement', value: 'event.name', width: 150 },
        { text: 'Animateur', value: 'profile', width: 150 },
        { text: 'Nom Complet', value: 'full_name', width: 150 },
        { text: 'Chaine de valeur', value: 'chain' },
        { text: 'Maillon', value: 'maillon' },
        { text: 'Departement', value: 'actor.department.name' },
        { text: 'Commune', value: 'actor.municipality.name' },
        { text: 'Ville/Village', value: 'actor.town.name' },
        { text: 'Valid. de niveau 1.', value: 'validator_1', width: 150 },
        { text: 'Valid. de niveau 2.', value: 'validator_2', width: 150 },
        { text: 'Actions', value: 'action', sortable: false }
      ],
      headers: [
        { text: 'Nom Evènement', value: 'event.name', width: 150 },
        { text: 'Animateur', value: 'event.name', width: 150 },
        { text: 'Code unique', value: 'actor.unique_code', width: 150 },
        { text: 'Chaine de valeur', value: 'chain', width: 150 },
        { text: 'Maillon', value: 'maillon', width: 150 },
        { text: 'Departement', value: 'actor.department.name' },
        { text: 'Commune', value: 'actor.municipality.name' },
        { text: 'Ville/Village', value: 'actor.town.name' },
        { text: 'Valid. de niveau 1.', value: 'validator_1', width: 150 },
        { text: 'Valid. de niveau 2.', value: 'validator_2', width: 150 },
        { text: 'Actions', value: 'action', sortable: false }
      ],
      actors_fields: {
        'Code Unique': 'unique_code',
        Sexe: 'gender',
        Age: 'age',
        Type: 'type',
        'Contact(s)': 'contact',
        Adresse: 'address',
        Langue: 'language',
        "Niveau d'instruction": 'instruction_level',
        Fonction: 'fonction',
        'Chaine de valeur': 'chain.name',
        'Maillon': 'maillon.name',
        Organisation: 'organization.name',
        Pays: 'country.name',
        Departement: 'department.name',
        Commune: 'municipality.name',
        Arrondissement: 'district.name',
        'Ville/Village': 'town.name'
      },
      admin_actors_fields: {
        'Code Unique': 'unique_code',
        Nom: 'last_name',
        'Prenom(s)': 'first_name',
        Sexe: 'gender',
        Age: 'age',
        Type: 'type',
        'Contact(s)': 'contact',
        Adresse: 'address',
        Langue: 'language',
        "Niveau d'instruction": 'instruction_level',
        Fonction: 'fonction',
        'Chaine de valeur': 'chain.name',
        'Maillon': 'maillon.name',
        Organisation: 'organization.name',
        Pays: 'country.name',
        Departement: 'department.name',
        Commune: 'municipality.name',
        Arrondissement: 'district.name',
        'Ville/Village': 'town.name'
      },

      no_validate_id: null,
      no_validate_index: null,
      reason: null,

      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      payload: {
        page: 1,
        size: 15
      },
      role: '',
      item: null,
      totalItems: null,
      rowsPerPageItems: 15,
      currentPage: 1,
      pagination: {
        last_page: 1,
      },
      actors: [],
      organisations: [],
      uri: '/api/actors-no-validate?include=event, event.user,actor,user_level_one,user_level_two,actor.maillon,actor.chain,actor.department,actor.municipality,actor.town'
    }
  },
  created() {
    this.event_id = this.$route.query.event_id
    this.$checkPermission('view validate actors')
    this.fetchUtils()
    this.getUtils()
    this.$store.dispatch('loadDepartments')
    this.$store.dispatch('fetchChains')
    this.$store.dispatch('fetchActorTypes')
    this.$store.dispatch('fetchSchoolLevels')
    this.$store.dispatch('fetchLanguages')
    this.$store.dispatch('fetchMaillons')
    this.$store.dispatch('fetchChains')
    this.$store.dispatch('fetchServices')
  },
  mounted() {
    if (this.authUser && this.authUser.user && this.authUser.user.roles[0]) {
      this.role = this.authUser.user.roles[0].name
    }
    this.filteredMunicipalities = []
    this.filteredDistricts = []
    this.filteredTowns = []
  },

  computed: {

    authUser() {
      return this.$store.getters.authUser
    },
    departments() { return this.$store.getters.getDepartments; },
    municipalities() { return this.$store.getters.getMunicipalities; },
    districts() { return this.$store.getters.getDistricts; },
    towns() { return this.$store.getters.getTowns; },

    ...mapGetters([
      'maillons',
      'chains',
      'services',
      'languages',
      'actor_types',
      'school_levels',
    ])
  },
  watch: {
    'rowsPerPageItems'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.payload.size = newVal;
        this.fetchUtils();
      }
    },
    'currentPage'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.payload.page = newVal;
        this.fetchUtils();
      }
    },
  },
  methods: {
    async fetchUtils() {
      this.loading = true
      let newUri = this.uri + '&page=' + this.payload.page + '&size=' + this.payload.size

      if (this.event_id) {
        newUri = newUri + '&event_id=' + this.event_id
      }
      const results = (await axios.get(newUri)).data

      if (results.data) {
        this.actors = results.data
        //console.log({ "actors": this.actors[0]["event"] });
        this.currentPage = results.current_page
        this.totalItems = results.total
        this.rowsPerPageItems = parseInt(results.per_page)
        this.pagination.last_page = results.last_page
      }

      this.loading = false
    },

    noValidateItem(item) {
      this.item = item;
      this.dialog_no_validate = true
      this.no_validate_id = item.id
    },
    showItem(item) {
      this.$router.push({ name: 'actors.show', params: { actorId: item.id } })
    },
    editItem(item) {
      this.$router.push({ name: 'actors.edit', params: { actorId: item.id } })
    },
    cancel() {
      this.isBulkDelete = false
      this.isSingleDelete = false
      this.isBulkGenerate = false
      this.dialog = false
      this.dialog_generate = false
      this.dialog_no_validate = false
    },

    choosen(payload) {
      if (!this.isValidate) {
        this.deleteItem(payload)
      } else {
        this.validateItem()
      }
    },

    deleting(item) {
      this.isValidate = false
      if (Array.isArray(item) && item.length > 0) {
        this.item = 'multiple'
        this.ids = this.selected.map((item) => {
          return item.id
        })
        this.isBulkDelete = true
        this.dialog_title = 'Suppression'
        this.delete_message =
          'Etes-vous sûr de vouloir supprimer ces acteurs ?'
        this.dialog = true
      } else {
        this.item = item.actor.unique_code
        if (Array.isArray(item) && item.length === 1) {
          this.actorId = item[0].id
        } else {
          this.actorId = item
        }

        this.isSingleDelete = true
        this.dialog_title = 'Suppression'
        this.delete_message = 'Etes-vous sûr de vouloir supprimer cet acteur ?'
        this.dialog = true
      }
    },
    validating(item) {
      this.ids = []
      this.isValidate = true
      if (Array.isArray(item) && item.length > 0) {
        this.ids = this.selected.map((item) => {
          return item.id
        })
        this.isBulkDelete = true
        this.dialog_title = 'Validation'
        this.delete_message =
          'Etes-vous sûr de vouloir valider ces acteurs ?'
        this.dialog_generate = true
      } else {
        this.ids.push(item.id)
        this.isSingleDelete = true
        this.dialog_title = 'Validation'
        this.delete_message = 'Etes-vous sûr de vouloir valider cet acteur ?'
        this.dialog_generate = true
      }
    },
    noValidating(item) {
      this.ids = []

      this.ids.push(item.id)
      this.isSingleDelete = true
      this.dialog_title = 'Rejet'
      this.delete_message = 'Etes-vous SURE de vouloir rejeter cet acteur ?'
      this.dialog_no_validate = true
      this.item = item


    },

    async noValidate(payload) {
      try {
        const { reason, item } = payload;

        // On récupère l'ID de l'acteur à rejeter
        const actorId = item.id;

        if (!actorId || !reason) {
          this.snackbar = true;
          this.snackbar_color = "error";
          this.snackbar_message = "L'ID ou la raison du rejet est manquant.";
          return;
        }

        // Requête POST vers l’API
        await axios.post(`/api/send-actor-delete-reason/${actorId}`, {
          reason,
          type: "Rejet"
        });

        // Réinitialisation des champs
        this.reason = "";
        this.dialog_no_validate = false;
        this.isNoValidating = true;

        // Message de succès
        this.snackbar = true;
        this.snackbar_color = "success";
        this.snackbar_message = "L’acteur a été rejeté avec succès.";

        // Rechargement de la liste
        this.fetchUtils();

      } catch (err) {
        console.error("Erreur lors du rejet de l'acteur :", err);
        this.snackbar = true;
        this.snackbar_color = "error";
        this.snackbar_message = "Une erreur est survenue lors du rejet.";
      }
    },

    async deleteItem(payload) {
      if (this.isBulkDelete && this.isBulkGenerate === false) {
        this.bulkDelete()
      } else if (this.isSingleDelete && this.isSingleGenerate === false) {
        this.deleteSingle(payload)
      }
      if (this.isBulkGenerate && this.isBulkDelete === false) {
        this.bulkGenerate()
      } else if (this.isSingleGenerate && this.isSingleDelete === false) {
        this.generateSingle()
      }
    },

    async validateItem() {
      this.loading = true
      await axios.post(`/api/actors-validate`, { ids: this.ids })
      this.loading = false
      this.reloadData()
      this.dialog_generate = false
      this.snackbar = true
      this.selected = []
      this.ids = []
      if (this.ids.length > 1) {
        this.snackbar_message = 'Acteurs validés avec succès!'
      } else {
        this.snackbar_message = 'Acteur validé avec succès!'
      }
    },

    async deleteSingle(payload) {
      console.log(this.actorId.id)
      this.loading = true
      this.reason = payload.reason;
      axios.post("/api/send-actor-delete-reason/" + this.actorId.id, {
        reason: this.reason,
        type: "Suppression"
      }).then(response => {

        axios.post(`/api/participants`, { ids: [this.actorId] })
        this.loading = true
        this.reloadData()
        this.dialog = false
        this.snackbar = true
        this.selected = []
        this.isBulkDelete = false
        this.isSingleDelete = false
        this.snackbar_message = 'Acteur supprimé avec succès!'

      }).catch(err => {
        console.log("Event deletion error ", err);
      })
    },
    async bulkDelete() {
      this.loading = true
      await axios.post(`/api/participants`, { ids: this.ids })
      this.loading = true
      this.reloadData()
      this.dialog = false
      this.snackbar = true
      this.selected = []
      this.isBulkDelete = false
      this.isSingleDelete = false
      this.snackbar_message = 'Acteurs supprimés avec succès!'
    },
    async reloadData() {
      this.loading = true
      let uri = '/api/actors-no-validate?include=event,actor,user_level_one,user_level_two,actor.maillon,actor.chain,actor.department,actor.municipality,actor.town'

      if (this.value_chain_id) {
        uri = uri + '&value_chain_id=' + this.value_chain_id
      }

      if (this.department_id) {
        uri = uri + '&department_id=' + this.department_id
      }
      if (this.municipality_id) {
        uri = uri + '&municipality_id=' + this.municipality_id
      }
      if (this.district_id) {
        uri = uri + '&district_id=' + this.district_id
      }
      if (this.town_id) {
        uri = uri + '&town_id=' + this.town_id
      }
      if (this.value_chain_id) {
        uri = uri + '&value_chain_id=' + this.value_chain_id
      } if (this.maillon_id) {
        uri = uri + '&maillon_id=' + this.maillon_id
      } if (this.organization_id) {
        uri = uri + '&organization_id=' + this.organization_id
      }
      if (this.age) {
        uri = uri + '&age=' + this.age
      }
      if (this.type) {
        uri = uri + '&type=' + this.type
      }
      if (this.gender) {
        uri = uri + '&gender=' + this.gender
      }
      if (this.instruction_level) {
        uri = uri + '&instruction_level=' + this.instruction_level
      }
      if (this.service_id) {
        uri = uri + '&service_id=' + this.service_id
      }
      if (this.language) {
        uri = uri + '&language=' + this.language
      }
      if (this.searchName.length !== 0) {
        uri = uri + '&searchName=' + this.searchName
      }
      this.uri = uri

      this.fetchUtils()

      this.loading = false
    },

    filters() {
      this.filter = !this.filter
    },
    async searchActors() {
      this.loader = true
      await this.reloadData()
      this.loader = false
    },
    async resetSearch() {
      this.filteredMunicipalities = []
      this.filteredDistricts = []
      this.filteredTowns = []
      this.searchName = ''
      this.value_chain_id = null
      this.maillon_id = null
      this.service_id = null
      this.organization_id = null
      this.type = null
      this.age = null
      this.gender = null
      this.language = null
      this.instruction_level = null
      this.department_id = null
      this.municipality_id = null
      this.district_id = null
      this.town_id = null
      this.loader = true
      await this.reloadData()
      this.loader = false
    },

    async getUtils() {
      const { data } = await axios.get('/api/organizations')
      this.organisations = data;
    },


    loadMunicipalities() {
      let departement = this.department_id;
      this.$store.dispatch('loadMunicipalities', departement);
    },

    loadDistricts() {
      let commune = this.municipality_id;
      this.$store.dispatch('loadDistricts', commune);
    },

    loadTowns() {
      let arrond = this.district_id;
      this.$store.dispatch('loadTowns', arrond);
    },
    removeDepartment() {
      this.department_id = null
      this.reloadData()
    },
    removeMunicipality() {
      this.municipality_id = null
      this.reloadData()
    },
    removeDistrict() {
      this.district_id = null
      this.reloadData()
    },
    removeTown() {
      this.town_id = null
      this.reloadData()
    },
    removeChain() {
      this.value_chain_id = null
      this.reloadData()
    },
    removeMaillon() {
      this.maillon_id = null
      this.reloadData()
    },
    removeService() {
      this.service_id = null
      this.reloadData()
    },
    removeOrganization() {
      this.organization_id = null
      this.reloadData()
    },
    removeType() {
      this.type = null
      this.reloadData()
    },
    removeGender() {
      this.gender = null
      this.reloadData()
    },
    removeAge() {
      this.age = null
      this.reloadData()
    },
    removeLanguage() {
      this.language = null
      this.reloadData()
    },
    removeLevel() {
      this.instruction_level = null
      this.reloadData()
    },

    exportActors() {
      axios
        .get('/api/actors/export-modified', {
          responseType: 'blob'
        })
        .then((resp) => {
          FileSaver.saveAs(
            resp.data,
            'liste des acteurs ajoutes-modifies.xlsx'
          )
        })
        .catch((err) => {
          this.$store.dispatch('responseMessage', {
            type: 'red',
            text: err
          })
        })
    }
  }
}
</script>
<style>
thead {
  background-color: #78b943;
}

thead th {
  color: #fff !important;
}

thead th i {
  color: #fff !important;
}

.v-pagination {
  flex-wrap: wrap;
}

.v-data-table td,
.v-data-table th {
  padding: 0 5px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/actors/index-validate.vue